<template>
  <div :class="data ? 'md:h-[80dvh] h-[28rem] overflow-hidden':''" class="relative  ">
      <DesktopMenu :isLoading="isLoading"/>
      <slot />
 
 </div>
 

</template>

<script>
import DesktopMenu from './DesktopMenu.vue'

export default {
  components: { DesktopMenu },
  props:['data','isLoading']

}
</script>

<style>

</style>